import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
const RouterLoadingFallback = () => (_jsx(Box, { display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", role: "status", "aria-live": "polite", "aria-busy": "true", children: _jsx(CircularProgress, { "aria-label": "Loading page" }) }));
export default RouterLoadingFallback;
